const dictMap = (object, mapFunc) => {
  return Object.keys(object).map((key) => {
    return mapFunc(object[key]);
  });
}

export default dictMap;
